import { useMutation } from '@tanstack/react-query';
import { deleteAgenticWorkflow } from 'services/api/WorkflowServiceAPI';

export const useDeleteWorkflow = () => {
    const { mutateAsync: deleteWorkflow, isPending } = useMutation({
        mutationFn: deleteAgenticWorkflow,
    });

    return {
        deleteWorkflow,
        isPending,
    };
};
